import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_DATABASE_LIST = '[Database] Get Database List',
  GET_DATABASE_LIST_SUCCESS = '[Database] Get Database List Success',
  GET_DATABASE_LIST_FAILED = '[Database] Get Database List Failed',

  GET_DATABASE_DETAILS = '[Database] Get Database Details',
  GET_DATABASE_DETAILS_SUCCESS = '[Database] Get Database Details Success',
  GET_DATABASE_DETAILS_FAILED = '[Database] Get Database Details Failed',
}

export const getDatabaseList = createAction(
  ActionTypes.GET_DATABASE_LIST
);

export const getDatabaseListSuccess = createAction(
  ActionTypes.GET_DATABASE_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getDatabaseListFailed = createAction(
  ActionTypes.GET_DATABASE_LIST_FAILED,
  props<{ error: any }>()
);

export const getDatabaseDetails = createAction(
  ActionTypes.GET_DATABASE_DETAILS,
  props<{ uuid: string }>()
);

export const getDatabaseDetailsSuccess = createAction(
  ActionTypes.GET_DATABASE_DETAILS_SUCCESS,
  props<{ data: any }>()
);

export const getDatabaseDetailsFailed = createAction(
  ActionTypes.GET_DATABASE_DETAILS_FAILED,
  props<{ error: any }>()
);